// src/routes/EmployeeRoutes.tsx
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';
import employeeRoutesConfig from './config/employeeRoutesConfig';

const EmployeeRoutes = employeeRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <ProtectedRoute element={<Component />} allowedRoles={['Employee', 'Admin', 'HR']} />
      </Suspense>
    }
  />
));
export default EmployeeRoutes;


